import { render, staticRenderFns } from "./TemplateSetting.vue?vue&type=template&id=84cb3586&"
import script from "./TemplateSetting.vue?vue&type=script&lang=ts&"
export * from "./TemplateSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports